export const Logo = ({ compact = false }) => (
    <img
        src="/assets/logo-full.png"
        alt="WorkAssign AI — AI Employees for Your Business"
        data-testid="brand-logo"
        className={`w-auto object-contain notranslate ${compact ? "h-9" : "h-12"}`}
        translate="no"
    />
);
